import { FunctionComponent } from "react";
import { AddRemoveButton } from "../components/buttons/AddRemoveButton/AddRemoveButton";
import { ShareEntityButton } from "../components/buttons/ShareEntityButton/ShareEntityButton";
import { EntityBackButton } from "../components/buttons/EntityBackButton/EntityBackButton";
import { Tour } from "@dto/Tour";
import { StopSummary } from "./StopSummary";
import { TourActionButtons } from "./TourActionButtons";
import { CollapsableText } from "@ui-kit/CollapsableText/CollapsableText";
import { parseEntityDescription } from "@lib/parseEntityDescription";
import { EntityItemList } from "@modules/entityList/EntityItemList/EntityItemList";

import "./TourView.css";

interface TourViewProps {
  tour: Tour;
}

const TourView: FunctionComponent<TourViewProps> = ({ tour }) => {
  return (
    <div className="tour-component">
      <div
        className="cover-photo"
        style={{
          backgroundImage: `url(${tour.coverPhotoUrl})`,
          height: "228px",
        }}>
        <div className="gradient"></div>
        <div className="cover-actions">
          <div className="cover-actions-top">
            <div className="cover-actions-top-left">
              <EntityBackButton />
            </div>
            <div className="cover-actions-top-right">
              <AddRemoveButton id={tour.id} type="Tour" />
              <ShareEntityButton entity={tour} />
            </div>
          </div>
        </div>
      </div>

      <div className="header">{tour.name}</div>

      <div className="tour-stop-summary-container">
        <StopSummary
          planItems={tour.planItems}
          routingEnabled={tour.routingEnabled}
          directions={tour.directionsData}
        />
      </div>

      <div className="actions">
        <TourActionButtons tour={tour} />
      </div>

      <div className="description">
        <CollapsableText
          title="Details"
          text={parseEntityDescription(tour.description)}
        />
      </div>

      <div className="plan-item-list-container">
        <EntityItemList
          planItems={tour.planItems}
          directions={tour.directionsData}
        />
      </div>
    </div>
  );
};

export { TourView };
